<ion-app>
  <ion-router-outlet [hidden]="loadingGuard"></ion-router-outlet>
  <div [hidden]="!loadingGuard" class="loading-screen">
    <img src="../assets/qidlogo.png">
  </div>
</ion-app>
